/**
 * AI Assist API client (P3-D Doc 39).
 */
import { api } from "./client";

export interface SuggestWorkflowRequest {
  intent: string;
  trigger_type?: string;
  context_form_codes?: string[];
  llm_provider?: string | null;
  llm_model?: string | null;
}

export interface SuggestWorkflowResponse {
  ok: boolean;
  graph?: Record<string, unknown> | null;
  explanation?: string;
  warnings?: string[];
  error?: string | null;
  raw_text?: string | null;
}

export interface SuggestFormRequest {
  intent: string;
  locale?: "vi" | "en";
  llm_provider?: string | null;
  llm_model?: string | null;
}

export interface SuggestFormResponse {
  ok: boolean;
  schema?: Record<string, unknown> | null;
  bindings?: Array<Record<string, unknown>>;
  explanation?: string;
  warnings?: string[];
  error?: string | null;
  raw_text?: string | null;
}

export const aiAssistApi = {
  suggestWorkflow: (body: SuggestWorkflowRequest) =>
    api.post<SuggestWorkflowResponse>(
      "/api/v1/admin/ai-assist/suggest-workflow",
      body,
    ),
  suggestForm: (body: SuggestFormRequest) =>
    api.post<SuggestFormResponse>("/api/v1/admin/ai-assist/suggest-form", body),
};
